export function convertInterestToText(interest: number) {
    return `${interest * 100}%  (oprocentowanie stałe w okresie 5 lat)`;
}
export function convertInterestToText(interest: number) {
    return `${interest * 100}%  (oprocentowanie stałe w okresie 5 lat)`;
}
